import { useMemo } from 'react';
import useSectionPaperStatuses from './useSectionPaperStatuses';
import { SECTION_PAPER_TIERS, sectionPaperProgress, sectionPapersOfTier } from '../utils/sectionPapers';

/**
 * Progress through an exam's section papers, for the Overview's Practice Topics rows:
 * { all, beginnings, foundations, beyond }, each a sectionPaperProgress result. The
 * statuses come from the same endpoint the Practice Topics tables read, so the
 * Overview and the pages never disagree about what is completed.
 */
export default function useSectionPaperTierProgress(exam, papers, completedList = []) {
  const dbPapers = useSectionPaperStatuses(exam, papers);
  return useMemo(() => {
    const progress = { all: sectionPaperProgress(papers, dbPapers, completedList) };
    SECTION_PAPER_TIERS.forEach((tier) => {
      progress[tier] = sectionPaperProgress(sectionPapersOfTier(papers, tier), dbPapers, completedList);
    });
    return progress;
  }, [papers, dbPapers, completedList]);
}
